import { watch } from "vue";
import { getToken, useCustomerIdRef } from "../api";
import { Api, type RequestParams } from "../machine-certificate-api-models";

const machineCertificateHttpClient = new Api({
	baseApiParams: {
		secure: true,
		headers: useCustomerIdRef().value
			? { "X-Organization-Id": useCustomerIdRef().value }
			: {},
	},
	securityWorker: async () => {
		const headers: Record<string, string> = {
			Authorization: `Bearer ${await getToken()}`,
		};
		return { headers };
	},
});

watch(
	useCustomerIdRef(),
	accountId => {
		if (!accountId) return;
		(
			machineCertificateHttpClient as unknown as {
				baseApiParams: RequestParams;
			}
		).baseApiParams.headers = {
			"X-Organization-Id": accountId ?? "",
		};
	},
	{ immediate: true },
);

export const initMachineCertificateClient = (defaultUrl: string) => {
	machineCertificateHttpClient.baseUrl = `${defaultUrl}`;
};

export const useMachineCertificateHttp = (): Api<unknown> =>
	machineCertificateHttpClient as Api<unknown>;
